export default "__VITE_ASSET__DkvpudBn__"